import { render, staticRenderFns } from "./EventCreatePage.vue?vue&type=template&id=83929a0a"
import script from "./EventCreatePage.vue?vue&type=script&lang=js"
export * from "./EventCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports